import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/shared/stores/AuthStore'

/**
 * Reactive flag that is true once the user is authenticated. Use it as the `enabled` option on
 * authenticated queries so they never fire before a token is available (which would 401) — e.g. the
 * composed-menu queries that mount as part of the app shell.
 */
export function useAuthReady() {
  const { isUserAuthenticated } = storeToRefs(useAuthStore())

  return isUserAuthenticated
}
